import {
    mdiArrowDown,
    mdiArrowUp,
    mdiEarth,
    mdiMapSearch,
    mdiPause,
    mdiPlay,
    mdiPlus,
    mdiMenuDown,
    mdiMenuUp,
    mdiMinus,
    mdiStop,
} from "@mdi/js";

export default {
    arrowDown: mdiArrowDown,
    arrowUp: mdiArrowUp,
    globe: mdiEarth,
    mapSearch: mdiMapSearch,
    pause: mdiPause,
    play: mdiPlay,
    plus: mdiPlus,
    menuDown: mdiMenuDown,
    menuUp: mdiMenuUp,
    minus: mdiMinus,
    stop: mdiStop,
};
